import React from 'react';
import WaiverViewField from '../WaiverViewField';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface WaiverCategorySelectorProps {
  label: string;
  value: string;
  readonly?: boolean;
  onChange?: (value: string) => void;
  errorTooltip?: boolean;
  onClick?: () => void;
}

class WaiverCategorySelector extends React.Component<WaiverCategorySelectorProps> {
  categories: string[];

  constructor(props: WaiverCategorySelectorProps) {
    super(props);
    this.categories = [
      'Weather',
      'Airport Infrastructure',
      'Industrial Action',
      'Non-violent Demonstration',
      'Airline Systems/Technology Issue',
      'Security Incident',
      'Natural Disaster',
      'Civil Unrest',
      'Epidemic or Pandemic',
      'Other'
    ];
  }

  handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  };

  render() {
    const { label, value, readonly, errorTooltip } = this.props;

    return (
      <div className="form-group">
        {!readonly ? (
          <>
            <label htmlFor="waiverCategoryInput">{label}*:</label>
            <OverlayTrigger delay={{ hide: 450, show: 300 }} show={errorTooltip} placement="bottom"
            overlay={(props) => (
              <>
                <Tooltip {...props} bsPrefix='waiver-error-tooltip popover category-error-tooltip'>
                  <div className="popover-inner">
                    <div className="popover-content">
                      <span className="sprites sprite-details-selected-24"></span>Please fill this field.
                    </div>
                  </div>
                </Tooltip>
              </>
            )}><select
              className="dropdown-toggle form-control"
              id="waiverCategoryInput"
              value={value || ''}
              onChange={this.handleChange}
              required
              onClick={this.props.onClick}
            >
              <option value="" disabled>---Select Category---</option>
              {this.categories.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select></OverlayTrigger>
          </>
        ) : (
          <WaiverViewField label={label} value={value} />
        )}
      </div>
    );
  }
}

export default WaiverCategorySelector;